const finite = (value) => typeof value === 'number' && Number.isFinite(value);

// channels contains measurements of the SAME spike on different recording channels.
export const spikeChannelRows = (waveform, primaryChannel, nearby = true) => {
  const primary = waveform.channel ?? primaryChannel;
  const supplied = Array.isArray(waveform.channels) ? waveform.channels : [];
  const rows = [{ channel: primary, amplitude: waveform.amplitude, timePoints: waveform.timePoints }, ...supplied];
  const seen = new Set();
  return rows.filter((row) => {
    const key = String(row.channel);
    if (seen.has(key) || (!nearby && key !== String(primary))) return false;
    if (!Array.isArray(row.amplitude) || row.amplitude.length < 2 || !row.amplitude.every(finite)) return false;
    seen.add(key);
    return true;
  }).map((row) => {
    const x = Array.isArray(row.timePoints) && row.timePoints.length === row.amplitude.length
      ? row.timePoints : Array.isArray(waveform.timePoints) && waveform.timePoints.length === row.amplitude.length
        ? waveform.timePoints : row.amplitude.map((_, index) => index);
    const baseline = row.amplitude.reduce((sum, value) => sum + value, 0) / row.amplitude.length;
    return { channel: row.channel, primary: String(row.channel) === String(primary),
      x, y: row.amplitude.map((value) => value - baseline), raw: row.amplitude };
  }).filter((row) => row.x.every(finite) && row.x.every((value, i) => i === 0 || value > row.x[i - 1]))
    .sort((a, b) => Number(a.channel) - Number(b.channel));
};

export const cardPageScale = (cards) => {
  let amplitude = 0; let start = Infinity; let end = -Infinity;
  cards.forEach(({ rows }) => rows.forEach((row) => {
    row.y.forEach((value) => { amplitude = Math.max(amplitude, Math.abs(value)); });
    row.x.forEach((value) => { start = Math.min(start, value); end = Math.max(end, value); });
  }));
  return { amplitude: amplitude || 1, start: Number.isFinite(start) ? start : 0,
    end: Number.isFinite(end) && end > start ? end : 1 };
};

export const waveformCardPath = (row, lane, scale, laneHeight = 26) => row.x.map((x, index) => {
  const px = 34 + (x - scale.start) / (scale.end - scale.start) * 186;
  const py = 10 + (lane + 0.5) * laneHeight - row.y[index] / scale.amplitude * laneHeight * 0.42;
  return `${index ? 'L' : 'M'}${px.toFixed(2)},${py.toFixed(2)}`;
}).join(' ');
